import { Button, Card, Col, Divider, Dropdown, Form, Input, InputNumber, Menu, Modal, Select, Tabs } from "antd";
import { useHistory, useParams } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import { t } from "i18next";
import SimpleLayout from "../../core/components/layout/SimpleLayout";
import ApiService from "../../core/service/ApiService";
import FirmSelectList from "../firm/FirmSelectList";
import { useUser } from "../../core/context/UserContext";
import { OperationSubItemsEdit } from "./OperationSubItemsEdit";
import Helper from "../../core/Helper";

export default function OperationCreateEdit({ }) {
    const { operationId } = useParams();
    const [units, setUnits] = useState([]);
    const [operation, setOperation] = useState({})
    const [subItems, setSubItems] = useState([])
    const [allOperations, setAllOperations] = useState([])
    const { user } = useUser()

    const history = useHistory();
    const formRef = useRef();

    const getUnits = async () => {
        const res = await ApiService.Unit.GetUnitList();
        if (res.success) {
            setUnits(res.data)
        }
    }

    const getAllOperations = async () => {
        const res = await ApiService.Operation.GetAllOperationList();
        if (res.success) {
            setAllOperations(res.data)
        }
    }

    const getOperation = async () => {
        const res = await ApiService.Operation.GetOperation(operationId);
        if (res.success) {
            res.data.subItems = JSON.parse(res.data.subItems || '[]')
            setOperation(res.data)
            setSubItems(res.data.subItems || [])
            formRef.current.setFieldsValue({
                ...res.data
            })
        }
    }


    const onFinish = async (formData) => {
        // Boş customId'yi null'a çevir; boş string Guid? bind'inde hata verir.
        const customId = formData.customId ? formData.customId.trim() : null;
        if (operationId) {
            const res = await ApiService.Operation.EditOperation(operationId, {
                ...formData,
                customId: customId || null,
                subItems: JSON.stringify(subItems)
            })
        }
        else {
            const res = await ApiService.Operation.CreateOperation({
                ...formData,
                customId: customId || null,
                visible: formData.visible !== undefined ? formData.visible : true,
                subItems: JSON.stringify(subItems)
            });

            if (res.success) {
                history.push(`/app/system/operations/edit/${res.data}`)
            }
        }
    }

    useEffect(() => {
        if (operationId) {
            getOperation();
        }
    }, [operationId])

    useEffect(() => {
        getUnits()
        getAllOperations()
    }, [])

    return (
        <SimpleLayout>
            <Card
                title={!operationId ? t('New Operation') : `${t('Edit Operation')} ${operation && operation.name && ` - ${operation.name}`}`}
            >
                <Form
                    layout={'vertical'}
                    onFinish={onFinish}
                    ref={formRef}
                    initialValues={{ processMinute: 15 }}
                >
                    <Form.Item
                        name={'unitId'}
                        style={{ margin: 0, padding: 0 }}
                    >
                        <Select
                            size={'small'}
                            style={{ width: 200 }}
                        >
                            {
                                units.map(u => {
                                    return (
                                        <Select.Option key={u.id} value={u.id}>
                                            {u.name}
                                        </Select.Option>
                                    )
                                })
                            }
                        </Select>
                    </Form.Item>
                    <br />
                    <Tabs type={'card'}>
                        <Tabs.TabPane key={'general'} tab={t('General')}>
                            <Form.Item
                                label={t('Name')}
                                name={'name'}
                            >
                                <Input />
                            </Form.Item>

                            <Form.Item
                                label={t('Modality')}
                                name="modality"
                            >
                                <Select>
                                    <Select.Option value="CT">CT</Select.Option>
                                    <Select.Option value="MR">MR</Select.Option>
                                    <Select.Option value="US">US</Select.Option>
                                    <Select.Option value="OT">OT</Select.Option>
                                    <Select.Option value="XA">XA</Select.Option>
                                    <Select.Option value="MG">MG</Select.Option>
                                    <Select.Option value="PX">PX</Select.Option>
                                    <Select.Option value="SR">SR</Select.Option>
                                    <Select.Option value="DX">DX</Select.Option>
                                </Select>
                            </Form.Item>


                            <Form.Item
                                label={t('SUT Code-1')}
                                name={'sutCodePart1'}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                label={t('Loinc')}
                                name={'loinc'}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                label={t('HUV')}
                                name={'huv'}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                label={t('TTB')}
                                name={'ttb'}
                            >
                                <Input />
                            </Form.Item>

                            <Form.Item
                                label={t('Custom ID')}
                                name={'customId'}
                                tooltip={t('Leave empty to auto-generate. Operations sharing the same Custom ID are treated as the same procedure across units.')}
                                rules={[{
                                    pattern: /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                                    message: t('Invalid Custom ID format')
                                }]}
                            >
                                <Input allowClear placeholder={t('Auto-generated if empty')} />
                            </Form.Item>

                            <Form.Item
                                label={t('Copy Custom ID From Operation')}
                            >
                                <Select
                                    showSearch
                                    allowClear
                                    placeholder={t('Select an operation to copy its Custom ID')}
                                    optionFilterProp={'label'}
                                    onChange={(opId) => {
                                        const src = allOperations.find(o => o.id === opId)
                                        formRef.current.setFieldsValue({ customId: src ? src.customId : undefined })
                                    }}
                                    options={allOperations
                                        .filter(o => String(o.id) !== String(operationId))
                                        .map(o => ({
                                            value: o.id,
                                            label: `${o.unit?.name ? o.unit.name + ' / ' : ''}${o.name}${o.sutCodePart1 ? ' - ' + o.sutCodePart1 : ''}`
                                        }))}
                                />
                            </Form.Item>

                            <Form.Item
                                label={t('Process Minute')}
                                name={'processMinute'}
                            >
                                <InputNumber
                                    style={{ width: '100%' }}
                                />
                            </Form.Item>

                            <Form.Item
                                label={t('Current Operation Prices')}
                                name={'price'}
                            >
                                <InputNumber
                                    style={{ width: '100%' }}
                                    min={0}
                                />
                            </Form.Item>

                            <Form.Item
                                label={t('Tags')}
                                name={'tagList'}
                            >
                                <Select
                                    mode="tags"
                                    style={{ width: '100%' }}
                                    options={user?.tags?.map(t => ({ label: t.name, value: t.name, color: t.color }))}
                                />
                            </Form.Item>

                            {operationId && (
                                <Form.Item
                                    label={t('Visible')}
                                    name={'visible'}
                                    rules={[{ required: true }]}
                                >
                                    <Select
                                        style={{ width: '100%' }}
                                        options={[
                                            { value: true, label: t('true') },
                                            { value: false, label: t('false') }
                                        ]}
                                    />
                                </Form.Item>
                            )}
                            <br />
                        </Tabs.TabPane>
                        <Tabs.TabPane key={'sub-items'} tab={t('Sub Operations')}>
                            <OperationSubItemsEdit
                                operationId={operationId}
                                subItems={operation.subItems}
                                onSubItems={(items) => {
                                    setSubItems(items)
                                }}
                                onExcelImported={getOperation}
                            />
                        </Tabs.TabPane>
                    </Tabs>

                    <br />
                    <Form.Item>
                        <Button size={'small'} htmlType={'submit'} type={'primary'}>{t('Save')}</Button>
                    </Form.Item>
                </Form>
            </Card>
        </SimpleLayout>
    )
}